<h4 class="hoffset-10 card-title">{{ "StatisticsChart.Title" | translate }}</h4>

<bcu-local-spinner [size]="50" [visible]="!items"></bcu-local-spinner>

@if (chart && isAnyValue) {
    <div class="row">
        <div class="col-md-11">
            <canvas id="canvas">{{ chart }}</canvas>
        </div>
    </div>
}

<!--
<div class="card-body" *ngIf="!isAnyValue">
  <p class="card-text text-center size-20 voffset-100"> {{'General.NoData' | translate}}</p>
</div> -->
